export default __webpack_public_path__ + "static/media/Notif - Job Post Update.c85e7267.svg";